import { LocationIcon } from '@THC/components/Icons/Location';
import T, { MDText } from 'i18n-react';

import { IconTooltip } from 'Components/shared/IconTooltip';
import texts from 'Components/texts.json';
import { triggerDistanceTooltipHoverEvent } from 'Services/analytics/events';
import { applySessionReplayActionName, applySessionReplayMask } from 'Services/datadog/datadogRum';
import { MASKED_EVENT_VALUES } from 'Services/datadog/datadogRum.const';

import { getLocationText } from './DeliveryLocation.helper';
import LocalTexts from './DeliveryLocation.texts';
import type { DeliveryLocationProps } from './DeliveryLocation.types';

import styles from './DeliveryLocation.module.scss';

const LocalT = new MDText(LocalTexts);
T.setTexts(texts);

const { delivery } = MASKED_EVENT_VALUES;

const privacyParams = {
	address: applySessionReplayMask(),
	distance: applySessionReplayActionName(delivery.distance),
	location: applySessionReplayActionName(delivery.location),
};

export const DeliveryLocation: React.FC<DeliveryLocationProps> = ({ seller, shouldShowEstimatedCost }) => {
	const { area, country, distance, town } = seller;

	const locationText = getLocationText({ area, country, town });
	const distanceText = distance ? T.translate('vehicleDetails.location.distance', { distance }) : '';
	const hasDistanceText = Boolean(distanceText);
	const hasSellerLocation = seller.longitude && seller.latitude;

	if (!hasSellerLocation) {
		return null;
	}

	return (
		<section aria-label="Delivery location" className={styles.wrapper} id="deliveryLocation">
			{hasSellerLocation && (
				<address {...privacyParams.address} className={styles.info}>
					<span className={styles.location} {...privacyParams.location}>
						<LocationIcon filled={false} size="small" />
						{locationText}
					</span>
					<span className={styles.distance} {...privacyParams.distance}>
						{distanceText}
					</span>

					{hasDistanceText && shouldShowEstimatedCost && (
						<div className={styles.tooltip} id="deliveryDistanceTooltipContainer">
							<IconTooltip
								content={LocalT.translate('tooltipContent.mileage')}
								iconProps={{ filled: false }}
								maxWidth={'288px'}
								onMouseEnter={triggerDistanceTooltipHoverEvent}
								side="bottom"
							/>
						</div>
					)}
				</address>
			)}
		</section>
	);
};
